let realizations = []

export async function getEndpointData(endpoint) {
    let url = `${window.location.protocol}//${window.location.hostname}`;
    if ( window.location.hostname == 'localhost' ) {
        url = 'https://pl.bkfcarwash.info';
    }
    await fetch(`${url}/wp-json/wp/v2/realizations-map/${ endpoint }`)
        .then(resp => resp.json())
        .then(resp => {
            realizations = resp;
        })
}
export function getRealizations() {
    return realizations
}
